/**
 * @typedef PropsSizeSwatch
 * @property { string } url
 * @property { boolean } isActive
 * @property { string } text
 * @property { boolean } [isAvailable]
 * @property { string } title
 */

/**
 * Image will supercede hex which will supercede text
 * @param { PropsSizeSwatch } param0
 * @returns { React.FC }
 */
export const SizeSwatch = ({ url = '', isActive = false, text, isAvailable = true, title }) => {
  if (!text) {
    console.error('Must specify text for a swatch')
    return <></>
  }

  const isActiveStyling = isActive ? 'border-black' : ''
  const isAvailableStyling = isAvailable ? '' : 'cursor-not-allowed'

  if (!isAvailable || !url) {
    return (
      <button
        type="button"
        className={`flex h-10 w-1/2 items-center justify-center rounded-lg border p-2 text-center text-black text-sm ${isActiveStyling} ${isAvailableStyling} `}
        title={title}
      >
        {text}
      </button>
    )
  }

  return (
    <a
      type="button"
      className={`flex h-10 w-1/2 items-center justify-center rounded-lg border p-2 text-center text-black text-sm ${isActiveStyling} ${isAvailableStyling} `}
      href={url}
      title={title}
    >
      {text}
    </a>
  )
}
